import React from 'react'
import { useFormik } from 'formik'
import { FormattedMessage, useIntl } from 'react-intl'
import { Button, SvgIcon, Typography, InputLabel } from '@material-ui/core'
import { codesBulkImportFormValidation } from '../../utils/validationSchema'
import { FormLoader } from '../../components/Loader/FormLoader'
import { formStyles } from '../../components/Invoice/Steps/FormStyles'
import PlayArrowIcon from '@material-ui/icons/PlayArrow'
import { SingleCodeConsumer } from '../../context/SingleCodeContext'
import Alert from '@material-ui/lab/Alert'
import FormRadioGroupField from '../FormRadioGroupField'
import FormUploadField from '../FormUploadField'
import codeUsageTemplate from '../../components/CodesPageContent/files/CodeUsageBulkTemplate.xlsx'
import EGSCodeUsageTemplate from '../../components/CodesPageContent/files/NewCodeBulkTemplate.xlsx'
import AlertTitle from '@material-ui/lab/AlertTitle'
import CloudDownloadIcon from '@material-ui/icons/CloudDownload'


function ExcelIcon (props) {
  return (
    <SvgIcon fill="none" viewBox="0 0 96 96" strokeMiterlimit="10" strokeWidth="2" {...props}>
      <path stroke="#979593"
            d="M67.1716,7H27c-1.1046,0-2,0.8954-2,2v78 c0,1.1046,0.8954,2,2,2h58c1.1046,0,2-0.8954,2-2V26.8284c0-0.5304-0.2107-1.0391-0.5858-1.4142L68.5858,7.5858 C68.2107,7.2107,67.702,7,67.1716,7z"/>
      <path fill="none" stroke="#979593" d="M67,7v18c0,1.1046,0.8954,2,2,2h18"/>
      <path fill="#C8C6C4"
            d="M51 61H41v-2h10c.5523 0 1 .4477 1 1l0 0C52 60.5523 51.5523 61 51 61zM51 55H41v-2h10c.5523 0 1 .4477 1 1l0 0C52 54.5523 51.5523 55 51 55zM51 49H41v-2h10c.5523 0 1 .4477 1 1l0 0C52 48.5523 51.5523 49 51 49zM51 43H41v-2h10c.5523 0 1 .4477 1 1l0 0C52 42.5523 51.5523 43 51 43zM51 67H41v-2h10c.5523 0 1 .4477 1 1l0 0C52 66.5523 51.5523 67 51 67zM79 61H69c-.5523 0-1-.4477-1-1l0 0c0-.5523.4477-1 1-1h10c.5523 0 1 .4477 1 1l0 0C80 60.5523 79.5523 61 79 61zM79 67H69c-.5523 0-1-.4477-1-1l0 0c0-.5523.4477-1 1-1h10c.5523 0 1 .4477 1 1l0 0C80 66.5523 79.5523 67 79 67zM79 55H69c-.5523 0-1-.4477-1-1l0 0c0-.5523.4477-1 1-1h10c.5523 0 1 .4477 1 1l0 0C80 54.5523 79.5523 55 79 55zM79 49H69c-.5523 0-1-.4477-1-1l0 0c0-.5523.4477-1 1-1h10c.5523 0 1 .4477 1 1l0 0C80 48.5523 79.5523 49 79 49zM79 43H69c-.5523 0-1-.4477-1-1l0 0c0-.5523.4477-1 1-1h10c.5523 0 1 .4477 1 1l0 0C80 42.5523 79.5523 43 79 43zM65 61H55c-.5523 0-1-.4477-1-1l0 0c0-.5523.4477-1 1-1h10c.5523 0 1 .4477 1 1l0 0C66 60.5523 65.5523 61 65 61zM65 67H55c-.5523 0-1-.4477-1-1l0 0c0-.5523.4477-1 1-1h10c.5523 0 1 .4477 1 1l0 0C66 66.5523 65.5523 67 65 67zM65 55H55c-.5523 0-1-.4477-1-1l0 0c0-.5523.4477-1 1-1h10c.5523 0 1 .4477 1 1l0 0C66 54.5523 65.5523 55 65 55zM65 49H55c-.5523 0-1-.4477-1-1l0 0c0-.5523.4477-1 1-1h10c.5523 0 1 .4477 1 1l0 0C66 48.5523 65.5523 49 65 49zM65 43H55c-.5523 0-1-.4477-1-1l0 0c0-.5523.4477-1 1-1h10c.5523 0 1 .4477 1 1l0 0C66 42.5523 65.5523 43 65 43z"/>
      <path fill="#107C41"
            d="M12,74h32c2.2091,0,4-1.7909,4-4V38c0-2.2091-1.7909-4-4-4H12c-2.2091,0-4,1.7909-4,4v32 C8,72.2091,9.7909,74,12,74z"/>
      <path
        d="M16.9492,66l7.8848-12.0337L17.6123,42h5.8115l3.9424,7.6486c0.3623,0.7252,0.6113,1.2668,0.7471,1.6236 h0.0508c0.2617-0.58,0.5332-1.1436,0.8164-1.69L33.1943,42h5.335l-7.4082,11.9L38.7168,66H33.041l-4.5537-8.4017 c-0.1924-0.3116-0.374-0.6858-0.5439-1.1215H27.876c-0.0791,0.2684-0.2549,0.631-0.5264,1.0878L22.6592,66H16.9492z"/>
    </SvgIcon>
  )
}

const CodesBulkImportForm = ({ onSubmit, cancelDialog, currentAction, updateParentEntity }) => {
  const intl = useIntl()
  const classes = formStyles()
  const codesBulkImportFormActions = useFormik({
    initialValues: {
      bulkType: 'codeUsage',
      codesFile: null
    },
    validateOnBlur: false,
    validateOnChange: true,
    validateOnMount: true,
    isInitialValid: false,
    validationSchema: codesBulkImportFormValidation,
    onSubmit: ((values, formikHelpers) => {
      onSubmit(values, formikHelpers, updateParentEntity)
    })
  })

  const bulkTypes = [
    { key: 'codeUsage', name: intl.formatMessage({ id: 'codesBulkImport.bulkType.codeUsage' }) },
    { key: 'EGSCodeUsage', name: intl.formatMessage({ id: 'codesBulkImport.bulkType.EGSCodeUsage' }) }
  ]


  return (
    <SingleCodeConsumer>
      {({ bulkImportResponse, clearCodeData }) => (
        <form onSubmit={codesBulkImportFormActions.handleSubmit} noValidate autoComplete="off"
              className={classes.formWrapper}>
          {!!Object.keys(bulkImportResponse || {}).length ?
            <>
              <Typography className={classes.hintWrapper + ' ' + classes.FormRow} variant={'h5'}>
                <FormattedMessage id='CodesBulkImportProcess'
                                  values={{
                                    count: bulkImportResponse?.codesCount,
                                    strong: chunks => <strong>{chunks}</strong>
                                  }}/>
              </Typography>

              {!!bulkImportResponse?.passedCount &&
              <Alert severity="success" variant="outlined" className={classes.alertSpacing}>
                <AlertTitle><FormattedMessage id='CodesBulkImport.success.title' values={{
                  count: bulkImportResponse?.passedCount,
                  strong: chunks => <strong>{chunks}</strong>
                }}/></AlertTitle>
                <FormattedMessage id='CodesBulkImport.success.message'/>
              </Alert>}

              {!!bulkImportResponse?.errorsCount &&
              <Alert severity="error" variant="outlined" className={classes.alertSpacing}>
                <AlertTitle><FormattedMessage id='CodesBulkImport.error.title' values={{
                  count: bulkImportResponse?.errorsCount,
                  strong: chunks => <strong>{chunks}</strong>
                }}/></AlertTitle>
                <FormattedMessage id='CodesBulkImport.error.message'/>
                <div className={classes.alertButtonWrapper}>
                  <Button size={'large'} variant={'contained'} color={'secondary'}
                          onClick={bulkImportResponse?.exportResponse}
                          className={classes.codesBulkImport} startIcon={<CloudDownloadIcon/>}>
                    <FormattedMessage id='CodesBulkImport.error.Button'/>
                  </Button>
                </div>
                <FormattedMessage id='CodesBulkImport.error.hint'/>
              </Alert>}
            </> :
            <>
              <ol className={classes.codeBulkList}>
                <li>
                  <FormRadioGroupField name={'bulkType'} labelKey={'Fields.label.view.Code.bulkType'} list={bulkTypes}
                                       classes={classes} formActions={codesBulkImportFormActions} required row column/>
                </li>
                <li>
                  <div className={classes.FormItem + ` ${classes.FormRow}`}>
                    <InputLabel><FormattedMessage id={'Fields.label.view.Code.fileTemplate'}/>:
                    </InputLabel>
                    <Button className={classes.templateDownload + ' normal'} variant={'text'} color={'primary'}
                            startIcon={<ExcelIcon htmlColor="#fff"/>}
                            href={codesBulkImportFormActions.values.bulkType === 'EGSCodeUsage' ? EGSCodeUsageTemplate : codeUsageTemplate}
                            download={codesBulkImportFormActions.values.bulkType === 'EGSCodeUsage' ? 'NewCodeBulkTemplate.xlsx' : 'CodeUsageBulkTemplate.xlsx'}>
                      {codesBulkImportFormActions.values.bulkType === 'EGSCodeUsage' ? 'NewCodeBulkTemplate.xlsx' : 'CodeUsageBulkTemplate.xlsx'}
                    </Button>
                  </div>
                </li>
                <li>
                  <FormUploadField formActions={codesBulkImportFormActions} classes={classes} name={'codesFile'}
                                   labelKey={'Fields.label.view.Code.codesFile'} required row
                                   placeholderKey={'Fields.label.view.Code.codesFile.placeholder'}
                                   types={['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel', 'text/csv']}/>
                </li>
              </ol>

              <Typography className={classes.hintWrapper + ' ' + classes.FormRow} variant={'subtitle1'}>
                <FormattedMessage id='CodesBulkImportHint'
                                  values={{ strong: chunks => <strong>{chunks}</strong> }}/>
              </Typography>
            </>}

          <div className={classes.FormSubmitRow}>
            {!Object.keys(bulkImportResponse || {}).length &&
            <Button type="submit" variant='contained' size={'large'} color={'secondary'}
                    onClick={codesBulkImportFormActions.handleSubmit}
                    disabled={codesBulkImportFormActions.isSubmitting || !codesBulkImportFormActions.isValid}
                    startIcon={<PlayArrowIcon/>}
            >
              <FormattedMessage id={`AddNewDialog.AddNewRecord.${currentAction}`}/>
            </Button>}
            <Button variant='outlined' color='secondary'
                    onClick={!!bulkImportResponse?.passedCount ? () => {
                      updateParentEntity(true)
                      clearCodeData()
                    } : cancelDialog}
                    className={'cancel'}>
              <FormattedMessage
                id={!!Object.keys(bulkImportResponse || {}).length ? 'AddNewDialog.Close' : 'invoiceSteps.Cancel'}/>
            </Button>
          </div>
          {!!codesBulkImportFormActions.isSubmitting && <FormLoader loading={true}/>}
        </form>
      )}
    </SingleCodeConsumer>
  )
}

export default CodesBulkImportForm
